import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faBoxOpen, faImage, faStore, faTag } from '@fortawesome/free-solid-svg-icons';

import { InfoCuentasContext } from '../../Hooks/InfoCuentasContext';
import './Publicacion.css';

const VACIO = { tienda: '', categoria: '', titulo: '', descripcion: '', stock: '', precio: '', imagen: '', etiquetas: '', envio: '' };

const Publicacion = () => {
  const { tiendas } = useContext(InfoCuentasContext);
  const [filtros, setFiltros] = useState([]);
  const [form, setForm] = useState(VACIO);
  const [estado, setEstado] = useState('cargando');
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    let cancelado = false;
    fetch('/api/productos/filtros')
      .then((response) => {
        if (!response.ok) throw new Error('No pudimos cargar las categorias.');
        return response.json();
      })
      .then((data) => {
        if (!cancelado) {
          setFiltros(Array.isArray(data) ? data : []);
          setEstado('listo');
        }
      })
      .catch((error) => {
        if (!cancelado) {
          setEstado('error');
          setMensaje({ tipo: 'error', texto: error.message });
        }
      });
    return () => { cancelado = true; };
  }, []);

  const categorias = useMemo(() => filtros.filter((filtro) => filtro.idfiltropadre !== null), [filtros]);
  const cambiar = (campo) => (event) => {
    setForm((actual) => ({ ...actual, [campo]: event.target.value }));
    setMensaje(null);
  };

  const publicar = async (event) => {
    event.preventDefault();
    setGuardando(true);
    setMensaje(null);
    try {
      const response = await fetch('/api/crear_aviso', {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          Idtienda: form.tienda, Idfiltro: form.categoria, Titulo: form.titulo,
          Descripcion: form.descripcion, Stockproducto: form.stock, Precio: form.precio,
          Imagen1: form.imagen, Etiquetas: form.etiquetas, Condicionesenvio: form.envio,
        }),
      });
      const data = await response.json().catch(() => ({}));
      if (response.status === 401) {
        window.location.href = '/login';
        return;
      }
      if (!response.ok) throw new Error(data.error || 'No pudimos crear la publicacion.');
      setForm((actual) => ({ ...VACIO, tienda: actual.tienda }));
      setMensaje({ tipo: 'ok', texto: 'Publicacion creada.', id: data.Idaviso });
    } catch (error) {
      setMensaje({ tipo: 'error', texto: error.message });
    } finally {
      setGuardando(false);
    }
  };

  if (tiendas.length === 0) {
    return <section className="publicacion-empty"><FontAwesomeIcon icon={faStore} /><h2>Primero crea tu tienda</h2><p>Las publicaciones quedan asociadas a una tienda para que compradores y ventas tengan un origen claro.</p><Link to="/cuenta#crear-tienda">Crear tienda <FontAwesomeIcon icon={faArrowRight} /></Link></section>;
  }

  return (
    <section className="publicacion-formulario">
      <header className="publicacion-heading"><span>Catalogo de tu tienda</span><h2>Crear publicacion</h2><p>Publica productos de bienestar, alimentos y accesorios para tu comunidad.</p></header>
      <form onSubmit={publicar}>
        <fieldset><legend><FontAwesomeIcon icon={faStore} /> Donde se publica</legend><div className="publicacion-grid">
          <label>Tienda<select value={form.tienda} onChange={cambiar('tienda')} required><option value="">Elegir tienda</option>{tiendas.filter((tienda) => tienda.habilitada !== false).map((tienda) => <option key={tienda.idtienda} value={tienda.idtienda}>{tienda.nombre}</option>)}</select></label>
          <label>Categoria<select value={form.categoria} onChange={cambiar('categoria')} required disabled={estado !== 'listo'}><option value="">Elegir categoria</option>{categorias.map((categoria) => <option key={categoria.idfiltro} value={categoria.idfiltro}>{categoria.nombre}</option>)}</select></label>
        </div></fieldset>
        <fieldset><legend><FontAwesomeIcon icon={faBoxOpen} /> Producto</legend><div className="publicacion-grid">
          <label className="publicacion-wide">Titulo<input value={form.titulo} onChange={cambiar('titulo')} maxLength="180" required /></label>
          <label className="publicacion-wide">Descripcion breve<textarea value={form.descripcion} onChange={cambiar('descripcion')} rows="4" maxLength="1200" required /></label>
          <label>Precio<input type="number" min="0" step="0.01" value={form.precio} onChange={cambiar('precio')} required /></label>
          <label>Stock disponible<input type="number" min="0" step="1" value={form.stock} onChange={cambiar('stock')} required /></label>
          <label className="publicacion-wide"><span><FontAwesomeIcon icon={faImage} /> Imagen del producto</span><input type="url" value={form.imagen} onChange={cambiar('imagen')} placeholder="https://..." /></label>
        </div></fieldset>
        <fieldset><legend><FontAwesomeIcon icon={faTag} /> Informacion adicional</legend><div className="publicacion-grid">
          <label>Etiquetas<input value={form.etiquetas} onChange={cambiar('etiquetas')} placeholder="organico, sin TACC" /></label>
          <label>Entrega o retiro<input value={form.envio} onChange={cambiar('envio')} placeholder="Coordinar con la tienda" /></label>
        </div></fieldset>
        {mensaje && <div className={`publicacion-mensaje ${mensaje.tipo}`} role="status"><span>{mensaje.texto}</span>{mensaje.id && <Link to={`/aviso/${mensaje.id}`}>Ver publicacion <FontAwesomeIcon icon={faArrowRight} /></Link>}</div>}
        <footer className="publicacion-actions"><Link to="/cuenta#MisPublicaciones">Ver mis publicaciones</Link><button type="submit" disabled={guardando || estado !== 'listo'}>{guardando ? 'Publicando...' : 'Publicar producto'}</button></footer>
      </form>
    </section>
  );
};

export default Publicacion;
